// Generated by LEN0X Addon Frontend ABI v1.
import { registerAddon } from "./registry.js";
import addon_lenox_memberapp_0 from "../addons-installed/lenox_memberapp/0.7.0-rc6/memberAppAddon.jsx";

export function registerGeneratedAddons() {
  registerAddon(addon_lenox_memberapp_0);
}
